import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { AdminState } from './state';

const defaultState: AdminState = {
  users: [],
  roles: [],
  languages: [],
  systemFeatures: [],
  actions: [],
  lastRoleUpdated: null,
  currencies: [],
  countries: [],
  states: [],
  cities: [],
  accountProfiles: [],
  accounts: [],
  sponsors: []
};

export const adminModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
